/*
 * Deskon - collection filters (sections/deskon-collection-filters.liquid).
 *
 * Reads the products the section wrote as JSON, builds the drawer, and filters / sorts the cards of
 * the "Grille produits (paginee)" grid on the same page by showing, hiding and reordering them.
 *
 * THE DRAWER WORKS ON A DRAFT. Ticking a box changes the draft and the number in the button
 * ("Show 12 products"); the grid only changes on that button. Closing the drawer any other way
 * throws the draft away, so what the visitor sees is always what the bar's count says.
 *
 * RULES: options of one group are OR (Black or White), groups are AND (Black and Glass and
 * under £100). A slider only filters once it has been moved off its full range; a product with no
 * value for that measure is then left out, since it cannot be shown to fit.
 *
 * THE EDITORIAL TILES of the grid keep their slot (8th cell, 13th cell...) whatever the order,
 * using their phone slot below 750px (data-dk-pos / data-dk-pos-mobile, set by the grid section).
 * Unfiltered, a slot past the last product puts the tile at the end, as the Liquid does; once a
 * filter shortens the list too much to reach a tile's slot, that tile is hidden instead.
 */

(function () {
  'use strict';

  if (customElements.get('deskon-collection-filters')) return;

  var SORTS = [
    ['manual', 'Most relevant'],
    ['title-ascending', 'Alphabetically, A-Z'],
    ['title-descending', 'Alphabetically, Z-A'],
    ['price-ascending', 'Price, low to high'],
    ['price-descending', 'Price, high to low'],
    ['created-ascending', 'Date, old to new'],
    ['created-descending', 'Date, new to old'],
  ];

  /* Colour families. Order matters: the first match wins ("pink gold" is Gold, not Pink). */
  var COLOURS = [
    ['Black', '#211F1C', ['black', 'charcoal', 'graphite']],
    ['White', '#F7F4EE', ['ivory', 'off white', 'off-white', 'white']],
    ['Cream', '#E9DFCB', ['cream', 'beige', 'sand', 'linen', 'natural']],
    ['Grey', '#9C9284', ['grey', 'gray', 'stone']],
    ['Gold', '#C9A24B', ['pink gold', 'rose gold', 'gold', 'brass']],
    ['Silver', '#B9B7B2', ['silver', 'chrome', 'nickel']],
    ['Red', '#A63A2F', ['red', 'burgundy', 'brick', 'wine']],
    ['Orange', '#C0602F', ['orange', 'terracotta', 'rust']],
    ['Yellow', '#E4B93C', ['yellow', 'mustard', 'ochre']],
    ['Pink', '#E3A6A1', ['pink', 'blush', 'rose']],
    ['Green', '#5B6E4F', ['green', 'sage', 'olive']],
    ['Blue', '#3E5C76', ['blue', 'navy']],
    ['Brown', '#6B4A34', ['brown', 'walnut', 'wood', 'chestnut']],
  ];

  /* Material families. 'acrylic crystal' is plastic, so plastics are tested before glass. */
  var MATERIALS = [
    ['Plastic & Resin', ['acrylic', 'polycarbonate', 'resin', 'polymer', 'composite', 'plastic', 'pvc']],
    ['Glass', ['glass', 'crystal']],
    ['Metal', ['metal', 'iron', 'alumin', 'brass', 'chrome', 'steel', 'copper']],
    ['Marble & Stone', ['marble', 'stone', 'travertin', 'concrete']],
    ['Wood', ['wood', 'walnut', 'oak', 'bamboo', 'rattan']],
    ['Fabric', ['fabric', 'linen', 'cotton', 'paper']],
    ['Ceramic', ['ceramic', 'porcelain']],
  ];

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function colourFamily(name) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < COLOURS.length; i += 1) {
      for (var j = 0; j < COLOURS[i][2].length; j += 1) {
        if (n.indexOf(COLOURS[i][2][j]) !== -1) return COLOURS[i][0];
      }
    }
    return null;
  }

  function numbers(text) {
    return (String(text).match(/\d+(?:\.\d+)?/g) || []).map(Number);
  }

  /* "Ø: 14 cm / H: 19.5 cm", "W: 45 cm / H: 45 cm", "Ø: 30 / 40 / 50 cm — H: 6 cm",
     "Cone Ø: 35 cm / H: 51 cm | Bottle Ø: 26 cm / H: 46 cm" */
  function measure(dims, label) {
    var re = label === 'h' ? /\bH\s*:\s*([\d.\s\/]+?)\s*cm/gi : /(?:Ø|\bW|\bD)\s*:\s*([\d.\s\/]+?)\s*cm/gi;
    var out = [];
    var m;
    while ((m = re.exec(String(dims || '')))) out = out.concat(numbers(m[1]));
    return out;
  }

  function materials(features) {
    var line = String(features || '').split('\n').filter(function (l) {
      return /^\s*materials?\s*:/i.test(l);
    })[0];
    if (!line) return [];
    var parts = line.replace(/^\s*materials?\s*:/i, '').split(',');
    var found = [];
    parts.forEach(function (part) {
      var p = part.toLowerCase();
      for (var i = 0; i < MATERIALS.length; i += 1) {
        var hit = MATERIALS[i][1].some(function (k) { return p.indexOf(k) !== -1; });
        if (hit) {
          if (found.indexOf(MATERIALS[i][0]) === -1) found.push(MATERIALS[i][0]);
          break;
        }
      }
    });
    return found;
  }

  function displayName(title) {
    var t = String(title || '');
    var i = t.lastIndexOf(' - ');
    return (i === -1 ? t : t.slice(i + 3)).trim();
  }

  function prepare(p, index) {
    var colours = [];
    var source = (p.colours || []).slice();
    if (!source.length) {
      (p.options || []).forEach(function (o) {
        var n = String(o.name).toLowerCase();
        if ((n.indexOf('colour') !== -1 || n.indexOf('color') !== -1 || n.indexOf('finish') !== -1) && n.indexOf('temperature') === -1) {
          source = source.concat(o.values || []);
        }
      });
    }
    source.forEach(function (c) {
      var f = colourFamily(c);
      if (f && colours.indexOf(f) === -1) colours.push(f);
    });
    return {
      id: String(p.id),
      name: displayName(p.title),
      min: (p.min || 0) / 100,
      max: (p.max || p.min || 0) / 100,
      created: Number(p.created) || 0,
      colours: colours,
      materials: materials(p.features),
      h: measure(p.dims, 'h'),
      d: measure(p.dims, 'd'),
      index: index,
    };
  }

  function range(values) {
    if (!values.length) return null;
    var lo = Math.floor(Math.min.apply(null, values));
    var hi = Math.ceil(Math.max.apply(null, values));
    return hi > lo ? [lo, hi] : null;
  }

  function money(v) {
    return '£' + Math.round(v);
  }

  customElements.define(
    'deskon-collection-filters',
    class DeskonCollectionFilters extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        var dataTag = this.querySelector('[data-cf-data]');
        try {
          this.products = JSON.parse(dataTag.textContent).map(prepare);
        } catch (e) {
          console.warn('[deskon-filters] product data unreadable', e);
          return;
        }
        this._ready = true;

        this.drawer = this.querySelector('[data-cf-drawer]');
        this.overlay = this.querySelector('[data-cf-overlay]');
        this.body = this.querySelector('[data-cf-body]');
        this.applyBtn = this.querySelector('[data-cf-apply]');
        this.countEl = this.querySelector('[data-cf-count]');
        this.badge = this.querySelector('[data-cf-badge]');
        this.openBtn = this.querySelector('[data-cf-open]');

        this.bounds = {
          price: range([].concat.apply([], this.products.map(function (p) { return [p.min, p.max]; }))),
          h: range([].concat.apply([], this.products.map(function (p) { return p.h; }))),
          d: range([].concat.apply([], this.products.map(function (p) { return p.d; }))),
        };

        this.state = this.emptyState();
        this.draft = this.cloneState(this.state);
        this.bestOrder = null;

        this.build();
        this.bindGrid();

        var self = this;
        this.openBtn.addEventListener('click', function () { self.open(); });
        this.querySelector('[data-cf-close]').addEventListener('click', function () { self.close(); });
        this.overlay.addEventListener('click', function () { self.close(); });
        this.querySelector('[data-cf-clear]').addEventListener('click', function () {
          self.draft = self.emptyState();
          self.syncControls();
          self.updateApply();
        });
        this.applyBtn.addEventListener('click', function () { self.apply(); });
        this.onKey = function (event) {
          if (event.key === 'Escape') self.close();
        };
      }

      emptyState() {
        return {
          sort: 'manual',
          colours: [],
          materials: [],
          price: this.bounds.price ? this.bounds.price.slice() : null,
          h: this.bounds.h ? this.bounds.h.slice() : null,
          d: this.bounds.d ? this.bounds.d.slice() : null,
        };
      }

      cloneState(s) {
        return {
          sort: s.sort,
          colours: s.colours.slice(),
          materials: s.materials.slice(),
          price: s.price ? s.price.slice() : null,
          h: s.h ? s.h.slice() : null,
          d: s.d ? s.d.slice() : null,
        };
      }

      /* ---------------------------------------------------------------- drawer */

      group(title) {
        var g = el('div', 'dk-cf__group');
        g.appendChild(el('p', 'dk-cf__group-title', title));
        this.body.appendChild(g);
        return g;
      }

      build() {
        var self = this;
        this.controls = {};

        /* Sort */
        var sortGroup = this.group('Sort by');
        var sortList = el('div', 'dk-cf__sorts');
        sortList.setAttribute('role', 'radiogroup');
        this.controls.sorts = SORTS.map(function (s) {
          var b = el('button', 'dk-cf__sort', s[1]);
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.dataset.value = s[0];
          b.addEventListener('click', function () {
            self.draft.sort = s[0];
            self.syncControls();
          });
          sortList.appendChild(b);
          return b;
        });
        sortGroup.appendChild(sortList);

        /* Price */
        if (this.bounds.price) this.controls.price = this.slider('Price', 'price', money);

        /* Colour */
        var colourCounts = {};
        this.products.forEach(function (p) {
          p.colours.forEach(function (c) { colourCounts[c] = (colourCounts[c] || 0) + 1; });
        });
        var colourNames = COLOURS.filter(function (c) { return colourCounts[c[0]]; });
        if (colourNames.length) {
          var cg = this.group('Colour');
          var wrap = el('div', 'dk-cf__chips');
          this.controls.colours = colourNames.map(function (c) {
            var b = el('button', 'dk-cf__chip');
            b.type = 'button';
            b.dataset.value = c[0];
            b.setAttribute('aria-pressed', 'false');
            var dot = el('span', 'dk-cf__swatch');
            dot.style.backgroundColor = c[1];
            b.appendChild(dot);
            b.appendChild(el('span', 'dk-cf__chip-label', c[0]));
            b.appendChild(el('span', 'dk-cf__chip-count', String(colourCounts[c[0]])));
            b.addEventListener('click', function () { self.toggle('colours', c[0]); });
            wrap.appendChild(b);
            return b;
          });
          cg.appendChild(wrap);
        }

        /* Height, Diameter */
        var cm = function (v) { return Math.round(v) + ' cm'; };
        if (this.bounds.h) this.controls.h = this.slider('Height', 'h', cm);
        if (this.bounds.d) this.controls.d = this.slider('Diameter / width', 'd', cm);

        /* Material */
        var matCounts = {};
        this.products.forEach(function (p) {
          p.materials.forEach(function (m) { matCounts[m] = (matCounts[m] || 0) + 1; });
        });
        var matNames = MATERIALS.map(function (m) { return m[0]; }).filter(function (m) { return matCounts[m]; });
        if (matNames.length) {
          var mg = this.group('Material');
          var list = el('div', 'dk-cf__checks');
          this.controls.materials = matNames.map(function (m) {
            var b = el('button', 'dk-cf__check');
            b.type = 'button';
            b.dataset.value = m;
            b.setAttribute('aria-pressed', 'false');
            b.appendChild(el('span', 'dk-cf__box'));
            b.appendChild(el('span', 'dk-cf__check-label', m));
            b.appendChild(el('span', 'dk-cf__chip-count', String(matCounts[m])));
            b.addEventListener('click', function () { self.toggle('materials', m); });
            list.appendChild(b);
            return b;
          });
          mg.appendChild(list);
        }

        this.syncControls();
      }

      slider(title, key, format) {
        var self = this;
        var b = this.bounds[key];
        var g = this.group(title);
        var values = el('p', 'dk-cf__range-values');
        var lo = el('span', '', format(b[0]));
        var hi = el('span', '', format(b[1]));
        values.appendChild(lo);
        values.appendChild(hi);
        g.appendChild(values);

        var track = el('div', 'dk-cf__range');
        var fill = el('span', 'dk-cf__range-fill');
        track.appendChild(fill);
        var a = el('input');
        var z = el('input');
        [a, z].forEach(function (input, i) {
          input.type = 'range';
          input.min = b[0];
          input.max = b[1];
          input.step = 1;
          input.value = b[i];
          input.setAttribute('aria-label', title + (i ? ' maximum' : ' minimum'));
          input.addEventListener('input', function () {
            var x = Number(a.value);
            var y = Number(z.value);
            if (x > y) {
              if (input === a) a.value = y; else z.value = x;
            }
            self.draft[key] = [Number(a.value), Number(z.value)];
            self.syncControls();
            self.updateApply();
          });
          track.appendChild(input);
        });
        g.appendChild(track);

        return {
          sync: function () {
            var v = self.draft[key];
            a.value = v[0];
            z.value = v[1];
            lo.textContent = format(v[0]);
            hi.textContent = format(v[1]);
            var span = b[1] - b[0];
            fill.style.left = ((v[0] - b[0]) / span) * 100 + '%';
            fill.style.right = ((b[1] - v[1]) / span) * 100 + '%';
          },
        };
      }

      toggle(key, value) {
        var list = this.draft[key];
        var i = list.indexOf(value);
        if (i === -1) list.push(value); else list.splice(i, 1);
        this.syncControls();
        this.updateApply();
      }

      syncControls() {
        var d = this.draft;
        var c = this.controls;
        c.sorts.forEach(function (b) {
          var on = b.dataset.value === d.sort;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        (c.colours || []).forEach(function (b) {
          var on = d.colours.indexOf(b.dataset.value) !== -1;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        (c.materials || []).forEach(function (b) {
          var on = d.materials.indexOf(b.dataset.value) !== -1;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        ['price', 'h', 'd'].forEach(function (k) {
          if (c[k]) c[k].sync();
        });
      }

      /* ---------------------------------------------------------------- logic */

      narrowed(s, key) {
        var b = this.bounds[key];
        return !!(b && s[key] && (s[key][0] > b[0] || s[key][1] < b[1]));
      }

      matches(p, s) {
        if (s.colours.length && !p.colours.some(function (c) { return s.colours.indexOf(c) !== -1; })) return false;
        if (s.materials.length && !p.materials.some(function (m) { return s.materials.indexOf(m) !== -1; })) return false;
        if (this.narrowed(s, 'price') && (p.min > s.price[1] || p.max < s.price[0])) return false;
        var self = this;
        var fits = true;
        ['h', 'd'].forEach(function (k) {
          if (!self.narrowed(s, k)) return;
          if (!p[k].some(function (v) { return v >= s[k][0] - 0.5 && v <= s[k][1] + 0.5; })) fits = false;
        });
        return fits;
      }

      results(s) {
        var self = this;
        return this.products.filter(function (p) { return self.matches(p, s); });
      }

      activeCount(s) {
        var n = s.colours.length + s.materials.length;
        if (this.narrowed(s, 'price')) n += 1;
        if (this.narrowed(s, 'h')) n += 1;
        if (this.narrowed(s, 'd')) n += 1;
        return n;
      }

      label(n) {
        return n + (n === 1 ? ' product' : ' products');
      }

      updateApply() {
        var n = this.results(this.draft).length;
        this.applyBtn.textContent = n ? 'Show ' + this.label(n) : 'No matching products';
        this.applyBtn.disabled = n === 0;
      }

      sorted(list, sort) {
        var by = {
          manual: function (a, b) { return a.index - b.index; },
          'title-ascending': function (a, b) { return a.name.localeCompare(b.name); },
          'title-descending': function (a, b) { return b.name.localeCompare(a.name); },
          'price-ascending': function (a, b) { return a.min - b.min || a.index - b.index; },
          'price-descending': function (a, b) { return b.min - a.min || a.index - b.index; },
          'created-ascending': function (a, b) { return a.created - b.created; },
          'created-descending': function (a, b) { return b.created - a.created; },
        };
        if (sort === 'best-selling' && this.bestOrder) {
          var rank = this.bestOrder;
          return list.slice().sort(function (a, b) {
            var x = rank[a.id] == null ? 9999 : rank[a.id];
            var y = rank[b.id] == null ? 9999 : rank[b.id];
            return x - y;
          });
        }
        return list.slice().sort(by[sort] || by.manual);
      }

      loadBestSelling() {
        var self = this;
        if (this.bestOrder) return Promise.resolve();
        var url = this.dataset.collectionUrl + '?sort_by=best-selling&section_id=' + encodeURIComponent(this.dataset.sectionId);
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var tag = doc.querySelector('[data-cf-data]');
            var rank = {};
            JSON.parse(tag.textContent).forEach(function (p, i) { rank[String(p.id)] = i; });
            self.bestOrder = rank;
          })
          .catch(function (e) {
            console.warn('[deskon-filters] best-selling order unavailable', e);
          });
      }

      /* ------------------------------------------------------------------ grid */

      bindGrid() {
        var grid = document.querySelector('[data-deskon-grid] .resource-list');
        if (!grid) {
          console.warn('[deskon-filters] no product grid on this page');
          return;
        }
        this.grid = grid;
        this.cells = {};
        this.tiles = [];
        var self = this;
        Array.prototype.forEach.call(grid.children, function (cell, i) {
          var card = cell.querySelector('[data-product-id]');
          if (card) {
            self.cells[String(card.getAttribute('data-product-id'))] = cell;
          } else {
            var pos = Number(cell.getAttribute('data-dk-pos')) || i + 1;
            var posMobile = Number(cell.getAttribute('data-dk-pos-mobile')) || pos;
            self.tiles.push({ cell: cell, pos: pos, posMobile: posMobile });
          }
        });
        /* From here on this script places the tiles; the grid section's own placer stands down. */
        grid.setAttribute('data-dk-tiles-managed', '');
        this.mq = window.matchMedia('(max-width: 749px)');
        var rerender = function () { self.render(); };
        if (this.mq.addEventListener) this.mq.addEventListener('change', rerender);
        else this.mq.addListener(rerender);
        this.empty = el('div', 'dk-cf__empty');
        this.empty.hidden = true;
        this.empty.appendChild(el('p', 'dk-cf__empty-text', 'No products match these filters.'));
        var reset = el('button', 'dk-cf__empty-reset', 'Clear filters');
        reset.type = 'button';
        reset.addEventListener('click', function () {
          self.draft = self.emptyState();
          self.apply();
        });
        this.empty.appendChild(reset);
        grid.parentNode.insertBefore(this.empty, grid.nextSibling);
        this.render();
      }

      render() {
        if (!this.grid) return;
        var self = this;
        var list = this.sorted(this.results(this.state), this.state.sort);
        var visible = {};
        list.forEach(function (p) { visible[p.id] = true; });

        var order = list
          .map(function (p) { return self.cells[p.id]; })
          .filter(Boolean);
        /* A tile whose slot is past the last product is hidden rather than pushed to the end:
           two photographs after two filtered lamps read as more results, not as decoration. */
        var hiddenTiles = [];
        var mobile = this.mq && this.mq.matches;
        var filtered = this.activeCount(this.state) > 0;
        var slotOf = function (t) { return (mobile ? t.posMobile : t.pos) - 1; };
        this.tiles.slice().sort(function (a, b) { return slotOf(a) - slotOf(b); }).forEach(function (t) {
          var slot = slotOf(t);
          if (slot <= order.length) {
            order.splice(slot, 0, t.cell);
            t.cell.style.display = '';
          } else if (!filtered) {
            order.push(t.cell);
            t.cell.style.display = '';
          } else {
            t.cell.style.display = 'none';
            hiddenTiles.push(t.cell);
          }
        });

        Object.keys(this.cells).forEach(function (id) {
          var cell = self.cells[id];
          cell.style.display = visible[id] ? '' : 'none';
        });
        order.forEach(function (cell) { self.grid.appendChild(cell); });
        Object.keys(this.cells).forEach(function (id) {
          if (!visible[id]) self.grid.appendChild(self.cells[id]);
        });
        hiddenTiles.forEach(function (cell) { self.grid.appendChild(cell); });

        var n = list.length;
        this.grid.style.display = n ? '' : 'none';
        this.empty.hidden = n !== 0;
        this.countEl.textContent = this.label(n);
        var active = this.activeCount(this.state);
        this.badge.hidden = active === 0;
        this.badge.textContent = active ? String(active) : '';
      }

      apply() {
        var self = this;
        this.state = this.cloneState(this.draft);
        var ready = this.state.sort === 'best-selling' ? this.loadBestSelling() : Promise.resolve();
        this.applyBtn.disabled = true;
        ready.then(function () {
          self.render();
          self.close(true);
          var top = self.getBoundingClientRect().top + window.scrollY - 80;
          if (window.scrollY > top) window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        });
      }

      /* ------------------------------------------------------------- open/close */

      open() {
        this.draft = this.cloneState(this.state);
        this.syncControls();
        this.updateApply();
        this.overlay.hidden = false;
        this.drawer.hidden = false;
        var self = this;
        requestAnimationFrame(function () {
          self.classList.add('is-open');
        });
        document.documentElement.classList.add('dk-cf-lock');
        document.addEventListener('keydown', this.onKey);
        this.openBtn.setAttribute('aria-expanded', 'true');
        this.drawer.focus();
      }

      close(applied) {
        if (this.drawer.hidden) return;
        var self = this;
        this.classList.remove('is-open');
        document.documentElement.classList.remove('dk-cf-lock');
        document.removeEventListener('keydown', this.onKey);
        this.openBtn.setAttribute('aria-expanded', 'false');
        if (!applied) this.draft = this.cloneState(this.state);
        setTimeout(function () {
          self.drawer.hidden = true;
          self.overlay.hidden = true;
          self.updateApply();
        }, 260);
      }
    }
  );
})();
